import { CSSProperties } from "react";

export const useAspectRatio = () => {
  const getGreatestCommonDivisor = (width: number, height: number): number => (
    width % height ? getGreatestCommonDivisor(height, width % height) : height
  );

  const ratio = (width: number, height: number): string => {
    const gcd: number = getGreatestCommonDivisor(width, height);
    return `${width / gcd}/${height / gcd}`;
  };

  const aspectRatioStyles = (
    width: number | string | undefined,
    height: number | string | undefined,
  ): CSSProperties | undefined => {
    if (!width || !height) { return undefined; }
    return { aspectRatio: ratio(+width, +height) };
  };

  return {
    ratio,
    aspectRatioStyles,
  };
};
